import { isValidSubdomain } from '../subdomain.schema.js';
/**
 * Canonical app origin (no trailing slash).
 * Prefer APP_URL; fall back to FRONTEND_URL for legacy deployments.
 */
export function getAppUrlBase() {
    return (process.env.APP_URL ?? process.env.FRONTEND_URL ?? 'https://app.cnapse.ai').replace(/\/$/, '');
}
/**
 * Build a path-based tenant URL.
 *
 * @example
 * buildAppUrl('acme', '/login') → https://app.cnapse.ai/acme/login
 * buildAppUrl(null, '/provider/login') → https://app.cnapse.ai/provider/login
 */
export function buildAppUrl(tenantSubdomain, path, query) {
    const base = getAppUrlBase();
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const tenantPrefix = tenantSubdomain ? `/${tenantSubdomain}` : '';
    const url = `${base}${tenantPrefix}${normalizedPath}`;
    if (!query) {
        return url;
    }
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
        if (value !== undefined) {
            params.set(key, String(value));
        }
    }
    const qs = params.toString();
    return qs ? `${url}?${qs}` : url;
}
/**
 * Insight Field Mode lives at `/m/*` (optionally after a tenant prefix). The leading
 * `m` segment is never a tenant slug.
 */
export function isRootMobileFieldPath(pathname) {
    const normalized = pathname.replace(/\/+$/, '') || '/';
    return normalized === '/m' || normalized.startsWith('/m/');
}
/**
 * Extract tenant slug from the first path segment when it is a valid tenant subdomain.
 */
export function parseTenantSlugFromPath(pathname) {
    if (isRootMobileFieldPath(pathname)) {
        return null;
    }
    const segment = pathname.split('/').filter(Boolean)[0]?.toLowerCase();
    if (!segment || !isValidSubdomain(segment)) {
        return null;
    }
    return segment;
}
//# sourceMappingURL=app-url.js.map